import { render, staticRenderFns } from "./mobileHead.vue?vue&type=template&id=31bca2e8&scoped=true&"
import script from "./mobileHead.vue?vue&type=script&lang=js&"
export * from "./mobileHead.vue?vue&type=script&lang=js&"
import style0 from "./mobileHead.vue?vue&type=style&index=0&id=31bca2e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bca2e8",
  null
  
)

export default component.exports